<template>
  <span>{{ data | formatPrice }}</span>
</template>

<script>
export default {
  props: ['data']
}
</script>
